// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import HappyScroll from 'vue-happy-scroll'
import 'vue-happy-scroll/docs/happy-scroll.css'
import 'element-ui/lib/theme-chalk/index.css';
import 'wowjs/css/libs/animate.css'
import './mixin'
import './mixin/jsApi'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

import scroll from 'vue-seamless-scroll'
Vue.use(VideoPlayer)
Vue.use(scroll)



import heads from '@/components/heads';
import pagination from '@/components/pagination';
import foots from '@/components/foots';
import leftnavbar from '@/components/left_navbar';
import rightnavbar from '@/components/right_navbar';
import innerTop from '@/components/innerTop';
import scrollText from '@/components/scrollText';
Vue.component('heads', heads)
Vue.component('pagination', pagination)
Vue.component('foots', foots)
Vue.component('leftnavbar', leftnavbar)
Vue.component('rightnavbar', rightnavbar)
Vue.component('innerTop', innerTop)
Vue.component('scrollText', scrollText)

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import ch from './assets/languages/ch'
import en from './assets/languages/en'
const i18n = new VueI18n({
  locale: !localStorage.getItem("lang")
    ? "ch"
    : localStorage.getItem("lang"),
  messages: {
    'ch': ch,  // 本地资源文件，配2个语言，中文&英文，src下根据个人情况放置
    'en': en
  },
  silentTranslationWarn: true
});

// 全局英文过滤器
Vue.filter('i18Key', (item, key) => {
  if (i18n.locale == 'ch') {
    return item[key]
  } else {
    return item[key + 'En']
  }
})


const setlocalStorage = (str) => {
  const obj = {}
  obj[str] = localStorage.getItem(str)
  return obj
}

window.zhanlanRoute = [
	["fb5e89622d4241d8b1ecf956aad8", "mwcs"],
	["fb5e89622d4241d8b21ecf956aad8", "ias"],
	["fb5e89622d4241d8b2cbc1ec", "glcs"],
	["fb5e89622d4241d8b2cbc1ecf95", "icts"],
	["fb5e89622d4241d8b2cbc1ecf956a", "es"],
	["fb5e89622d4241d8b2cbc1ecf956aad", "ftis"],
	["fb5e89622d4241d8b2cbc1ecf956aad8", "rs"],
	["fb5e89622d4241d8b2cbcf956aad8", "stis"],
	["fb5e89622d4241d8b2ecf956aad8", "nmis"]
]

// import waicTabs from '@/components/tabs'
// Vue.component('waic-tabs', waicTabs)
let timer = null
let timer1 = null
const wscrollTop = (num) => {
  clearTimeout(timer)
  timer = setTimeout(() => {
    window.scrollTo(0, num)
  }, 300)
}

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper)
Vue.use(HappyScroll)
Vue.prototype.i18n = i18n;
router.beforeEach((to, from, next) => {
  if (to.query.headIndex) {
    localStorage.setItem('headIndex', to.query.headIndex)
  }
  if (to.query.leftIndex) {
    localStorage.setItem('leftIndex', to.query.leftIndex)
  }

  if (to.name === 'zhanlan' && to.query.uuid) { // 展览跳转固定链接
    try {
      next(window.zhanlanRoute.filter(x => x[0] === to.query.uuid)[0][1])
    } catch (error) {
      next()
    }
    return
  }
  if (to.query.shortLink) {
    localStorage.setItem('ExhibitDetail', '')
  }
  const ExhibitDetail = localStorage.getItem('ExhibitDetail') ? JSON.parse(localStorage.getItem('ExhibitDetail')) : ''
  
  if (to.name === 'news_publish') {
    if (to.query && to.query.pageType === 'release') {
      next('/release_page?pageType=release&headIndex=' + localStorage.getItem('headIndex') + '&leftIndex=' + localStorage.getItem('leftIndex'))
      return
    } else if (to.query && to.query.pageType === 'events') {
      next('/events_page?pageType=events&headIndex=' + localStorage.getItem('headIndex') + '&leftIndex=' + localStorage.getItem('leftIndex'))
    } else if (to.query && to.query.pageType === 'exhibitNews') {
      next(`/exhibitNews_page/${ to.query.uuid }?pageType=exhibitNews&uuid=` + to.query.uuid + '&headIndex=' + localStorage.getItem('headIndex') + '&leftIndex=' + localStorage.getItem('leftIndex'))
    } else if (to.query && to.query.pageType === 'goodNews') {
      next(`/goodNews_page?pageType=goodNews` + '&headIndex=' + localStorage.getItem('headIndex') + '&leftIndex=' + localStorage.getItem('leftIndex'))
    } else if (to.query && to.query.pageType === 'moreNews') {
      next(`/moreNews_page?pageType=moreNews` + '&headIndex=' + localStorage.getItem('headIndex') + '&leftIndex=' + localStorage.getItem('leftIndex'))
    } else {
      next('/news_page' + '?headIndex=' + localStorage.getItem('headIndex') + '&leftIndex=' + localStorage.getItem('leftIndex'))
    }
    return
  } else {
    if (!to.query.headIndex && to.fullPath.includes('?')) {
      next(to.fullPath + '&headIndex=' + localStorage.getItem('headIndex') + '&leftIndex=' + localStorage.getItem('leftIndex'))
    }
  }

  if (!to.meta || !to.meta.noKeep) {
    let scrollTops = localStorage.getItem('scrollTops')
    scrollTops = JSON.parse(scrollTops)
    if (scrollTops && scrollTops[to.name] && !to.meta.noKeep) {
      wscrollTop(scrollTops[to.name])
    }
  }
  if ((!from.meta || !from.meta.noKeep) && from.name !== to.name) {
    let scrollTops = localStorage.getItem('scrollTops')
    scrollTops = JSON.parse(scrollTops)
    if (!scrollTops) {
      scrollTops = {}
    }
    
    scrollTops[from.name] = document.documentElement.scrollTop
    localStorage.setItem('scrollTops', JSON.stringify(scrollTops))

    if ( !((!to.meta || !to.meta.noKeep) && scrollTops && scrollTops[to.name] && !to.meta.noKeep) ) {
      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 200)
    }
    
  }

  clearTimeout(timer1)
  try {
    const pageIsExhibit = localStorage.getItem('pageIsExhibit')
    if (JSON.parse(pageIsExhibit)) {
      const arr = JSON.parse(pageIsExhibit)
      if (arr.length > 10) {
        arr.shift()
        localStorage.setItem('pageIsExhibit', JSON.stringify(arr))
      }
    }
    if (localStorage.getItem('popstate') === '1') {
      localStorage.setItem('popstate', '')
    } else {
      timer1 = setTimeout(() => {
        if (localStorage.getItem('ExhibitDetail') && localStorage.getItem('ExhibitDetail').length > 5) {
          const pageIsExhibit = localStorage.getItem('pageIsExhibit')
          if (pageIsExhibit) {
            localStorage.setItem('pageIsExhibit', JSON.stringify([...JSON.parse(pageIsExhibit), {flag: true, ...setlocalStorage('leftIndex'), ...setlocalStorage('headIndex') }]))
          } else {
            localStorage.setItem('pageIsExhibit', JSON.stringify([{flag: true, ...setlocalStorage('leftIndex'), ...setlocalStorage('headIndex') }]))
          }
        } else {
          const pageIsExhibit = localStorage.getItem('pageIsExhibit')
          if (pageIsExhibit) {
            localStorage.setItem('pageIsExhibit', JSON.stringify([...JSON.parse(pageIsExhibit), {flag: false, ...setlocalStorage('leftIndex'), ...setlocalStorage('headIndex') }]))
          } else {
            localStorage.setItem('pageIsExhibit', JSON.stringify([{flag: false, ...setlocalStorage('leftIndex'), ...setlocalStorage('headIndex') }]))
          }
        }
      }, 1000)
    }
  } catch(err) {
    
  }
  if (from.fullPath === '/' && to.fullPath.includes('exhibitUuid') && !(ExhibitDetail && ExhibitDetail.name)) {
    localStorage.setItem('zhanlanDetail', to.fullPath)
    next(`/zhanlan?uuid=${ to.query.exhibitUuid }`)
    return
  }
  if (from.fullPath != to.fullPath && ExhibitDetail && ExhibitDetail.name && !to.fullPath.includes('exhibitUuid')) {
    next(to.fullPath.includes('?') ? to.fullPath + '&exhibitUuid=' + ExhibitDetail.uuid : to.fullPath + '?exhibitUuid=' + ExhibitDetail.uuid)
  } else {
    next()
  }
  
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  components: { App },
  template: '<App/>'
})

const arr = [
	["数控机床与金属加工展", "/mwcs"],
	["工业自动化展", "/ias"],
	["节能与工业配套展", "/glcs"],
	["新一代信息技术应用展", "/icts"],
	["能源技术与设备展", "/es"],
	["新能源与智能网联汽车展", "/ftis"],
	["机器人展", "/rs"],
	["科技创新展", "/stis"],
	["新材料产业展", "/nmis"]
]
router.afterEach((to, from, next) => {
  const ExhibitDetail = localStorage.getItem('ExhibitDetail') ? JSON.parse(localStorage.getItem('ExhibitDetail')) : ''
  let flag = false
  arr.forEach(x => {
    if (x[1] === location.pathname) {
      Vue.prototype.$jsAPI('page', 'Common_pageView', { page_duration: 1, site_name: x[0]  })
      flag = true
    }
  })
  if (flag) return
  Vue.prototype.$jsAPI('page', 'Common_pageView', { page_duration: 1, site_name: ExhibitDetail && ExhibitDetail.name ? ExhibitDetail.name : '官网'  })
})



// WEBPACK FOOTER //
// ./src/main.js